import {observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    Container, ContainerButtonHeader,
    ContainerInputSearch,
    Content,
    ContentInputSearch,
    ContentLoading, ContentTextNoResults, Icon,
    Text
} from "./styled";
import LoadingInfinityScroll from "@dropDesk/presentation/components/loadings/loading_infinity_scroll";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import {SpinLoading} from "@dropDesk/presentation/components/loadings/spin";
import ContactList from "@dropDesk/presentation/components/contact_list";
import {useBetween} from "use-between";
import {useModalChat} from "@dropDesk/presentation/pages/chat/ui/contact_list/modals/handle_change_visible";
import {Tooltip} from "antd";
import ModalsChat from "@dropDesk/presentation/pages/chat/ui/contact_list/modals";
import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserController} from "@dropDesk/presentation/pages/user/controller/user.controller";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import ButtonNewExpanded from "@dropDesk/presentation/components/buttons/button_new_expanded";
import CompanyFilter from "@dropDesk/presentation/pages/chat/ui/contact_list/company_filter";
import {getFiltersFromLocalStorage} from "@dropDesk/utils/helpers/common";

export const ContactsList = (observer((
    {
        handleInitChat,
        maxWidthContainer,
        onClickContact,
        contactLoadingId
    }: {

        handleInitChat: (ticket: TicketEntity) => void
        maxWidthContainer: number
        onClickContact: (contact: UserEntity) => void
        contactLoadingId: string | null
    }
) => {

    const userController: UserController = useInjection(UserController);

    useEffect(() => {
        initializeContacts().then();
    }, []);

    const onSearchContacts = (searchParam?: string) => {
        userController.list(searchParam ?? userController.searchParam, undefined, undefined, true);
    }

    const initializeContacts = async () => {
        const filters = getFiltersFromLocalStorage();
        userController.setClientFilter(filters.contactFilterByClient ?? null);
        userController.tableUsers.limit = ConstantsKeys.defaultLimit;
        userController.setRole(UserRole.userClient);
        await userController.list(userController.searchParam, undefined, undefined, true, ConstantsKeys.defaultLimit);
    }

    const [idContactSelected, setIdContactSelected] = useState<string | null>(null);
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const {setVisibleModalEditClient} = useBetween(useModalChat);

    return (
        <Container bordercolor={colors.border}>
            <ContainerInputSearch>
                <ContentInputSearch>
                    <InputSearchGeneric
                        inputSearchPlaceholder="Pesquise por contatos"
                        loading={userController.loading}
                        onSearch={(value) => onSearchContacts(value)}
                        size={'large'}
                        defaultLimitInputSearch={ConstantsKeys.defaultNewLimitInputSearch}
                    />
                </ContentInputSearch>
                <CompanyFilter
                    clientFilter={userController.clientFilter}
                    setClientFilter={(clientFilter) => userController.setClientFilter(clientFilter)}
                    loading={userController.loading}
                    onSearch={() => onSearchContacts()}
                />
                <ButtonNewExpanded
                    onClick={() => setVisibleModalEditClient({visible: true, idClient: null})}
                    loading={false}
                    tooltip={'Adicionar novo contato'}
                />
            </ContainerInputSearch>
            <Content>
                {userController.loading && userController.tableUsers.data.length === 0 &&
                    <ContentLoading>
                        <SpinLoading
                            size={"large"}
                            color={colors.text}
                            tip={"Carregando ..."}
                        />
                    </ContentLoading>
                }
                {!userController.loading && userController.tableUsers.data.length === 0 &&
                    <ContentTextNoResults>
                        <DropDeskIcon icon={ICONS_DROPDESK.emptyFolder} size={55} color={colors.hintInverse}/>
                        <Text color={colors.text}>
                            {userController.clientFilter
                                ? 'Nenhum contato encontrado para esta empresa.'
                                : 'Nenhum contato encontrado.'}
                        </Text>
                    </ContentTextNoResults>
                }

                {userController.tableUsers.data.map((contact) => {
                    return (
                        <div key={contact.id}>
                            <ContactList
                                maxWidthContainer={maxWidthContainer}
                                onClick={() => {
                                    setIdContactSelected(contact.id);
                                    onClickContact(contact);
                                }}
                                loading={contactLoadingId === contact.id}
                                contact={contact}
                                searchParam={userController.searchParam}
                                idContactSelected={idContactSelected}
                                onClickEditClient={(idClient) => {
                                    setIdContactSelected(idClient);
                                    setVisibleModalEditClient({visible: true, idClient})
                                }}
                            />
                        </div>
                    )
                })}

                {userController.tableUsers.hasMore &&
                    <LoadingInfinityScroll
                        loading={userController.loading && !userController.loadingMessage}
                        loadMore={() => userController.loadMoreDataFromPage()}
                        label={'Carregar mais contatos'}
                        labelLoading={'Carregando mais contatos...'}
                    />}

            </Content>
            <ModalsChat
                handleSubmitEditClient={() => onSearchContacts()}
                handleSubmitNewChat={(ticket) => handleInitChat(ticket)}
            />
        </Container>
    )
}));
